import { ZIndexLayer as SdkZIndexLayer } from "@product/scmp-sdk";

export enum ZIndexLayer {
  ArticleAcknowledgementGateOverlay = 1299,
  AppBar = 1300,
  AppTooltip = ZIndexLayer.AppBar - 10,
  DropdownSelect = 1350,
  Drawer = 1400,
  Modal = SdkZIndexLayer.Modal,
  SnackBar = 1600,
  Tooltip = SdkZIndexLayer.Tooltip,
  HamburgerMenu = 1800,
  EditionInvitation = 1900,
  GoogleOneTapSignIn = 2000,
  OnboardingDialog = 3000,
}
